import defer from 'hs-promise-utils/defer';
import get from 'hs-lodash/get';
const SERVICE_WORKER_DATABASE_NAME = 'hs.notifications-service-worker';
const SERVICE_WORKER_EVENTS_STORE = 'change-events';
const PUSH_SUBSCRIPTION_CHANGED_KEY = 'push-subscription-changed';

/**
 * Service worker will post this to all clients following it handling a push subscription
 * changed event. The app should respond by resubscribing for browser notifications.
 */
const PUSH_SUBSCRIPTION_CHANGED_MESSAGE_TYPE = 'push-subscription-changed-message';
export const isPushSubscriptionChangedMessageEvent = messageEvent => get(messageEvent.data, 'type') === PUSH_SUBSCRIPTION_CHANGED_MESSAGE_TYPE;
export const createPushSubscriptionChangedMessage = () => {
  return {
    type: PUSH_SUBSCRIPTION_CHANGED_MESSAGE_TYPE
  };
};

/** IndexDB connection is closing, e.g. on page unload or database is deleted */
const isInvalidStateError = error => {
  return error instanceof DOMException && error.name === 'InvalidStateError';
};
const openServiceWorkerDatabase = () => {
  const deferred = defer();
  const request = indexedDB.open(SERVICE_WORKER_DATABASE_NAME, 1);
  request.onupgradeneeded = event => {
    const db = event.target.result;
    if (!db.objectStoreNames.contains(SERVICE_WORKER_EVENTS_STORE)) {
      db.createObjectStore(SERVICE_WORKER_EVENTS_STORE);
    }
  };
  request.onerror = () => {
    console.error('Failed to open notifications service worker DB');
    deferred.reject(request.error);
  };
  request.onsuccess = () => {
    deferred.resolve(request.result);
  };
  return deferred.promise;
};
export const writePushSubscriptionChangedEvent = async () => {
  const deferred = defer();
  try {
    const db = await openServiceWorkerDatabase();
    const transaction = db.transaction([SERVICE_WORKER_EVENTS_STORE], 'readwrite');
    const objectStore = transaction.objectStore(SERVICE_WORKER_EVENTS_STORE);
    const request = objectStore.put(true, PUSH_SUBSCRIPTION_CHANGED_KEY);
    request.onsuccess = () => {
      deferred.resolve();
    };
    request.onerror = () => {
      deferred.reject(request.error);
    };
    await deferred.promise;
  } catch (e) {
    console.error('Failed to write push subscription changed event', e);
  }
};
export const hasPushSubscriptionChangedEvent = async () => {
  const deferred = defer();
  try {
    const db = await openServiceWorkerDatabase();
    const transaction = db.transaction([SERVICE_WORKER_EVENTS_STORE], 'readonly');
    const objectStore = transaction.objectStore(SERVICE_WORKER_EVENTS_STORE);
    const request = objectStore.get(PUSH_SUBSCRIPTION_CHANGED_KEY);
    request.onsuccess = () => {
      const value = request.result;
      deferred.resolve(!!value);
    };
    request.onerror = () => {
      deferred.reject(request.error);
    };
    return await deferred.promise;
  } catch (e) {
    if (isInvalidStateError(e)) {
      return false;
    }
    console.error('Failed to get push subscription changed event', e);
  }
  return false;
};
export const clearPushSubscriptionChangedEvent = async () => {
  const deferred = defer();
  try {
    const db = await openServiceWorkerDatabase();
    const transaction = db.transaction([SERVICE_WORKER_EVENTS_STORE], 'readwrite');
    const objectStore = transaction.objectStore(SERVICE_WORKER_EVENTS_STORE);
    const request = objectStore.delete(PUSH_SUBSCRIPTION_CHANGED_KEY);
    request.onsuccess = () => {
      deferred.resolve();
    };
    request.onerror = () => {
      deferred.reject(request.error);
    };
    await deferred.promise;
  } catch (e) {
    if (isInvalidStateError(e)) {
      return;
    }
    console.error('Failed to clear push subscription changed event', e);
  }
};